import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/inventory/po')({
  loader: () => {
    return {
      crumb: 'Purchase Order (PO)',
    }
  },
})
